import {
  useFind,
} from 'src/api/APIHooks';
import { defaultQueryConfig } from 'common/utils/queryDefaults';

export const useFindAllPlan = (ids, params = { queryConfig: defaultQueryConfig }) => useFind(
  'plans',
  {
    id: ids,
  },
  {
    queryConfig: {
      placeholderData: undefined,
      enabled: !!ids,
    },
    ...params,
  },
);
